import axiosConfig from '../axiosConfig';

export interface LoginResponse {
	message: string;
	mfa_token?: string;
	mfa_required?: boolean;
	hashed?: string;
	expire?: number;
}
export async function Login(username: string, password: string): Promise<LoginResponse> {
	return axiosConfig.instance.post('admin/login', { username, password }).then((response) => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		const data = response?.data;
		// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		if (response?.status === 202 && data?.mfa_token) {
			return {
				message: 'MFA required.',
				// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
				mfa_token: data.mfa_token as string,
				mfa_required: true,
				// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
				hashed: data.hashed as string,
				// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
				expire: data.expire as number,
			};
		}

		return { message: 'Successfully logged in.' };
	});
}

export async function LoginMFA(mfaToken: string, otp: string): Promise<LoginResponse> {
	return axiosConfig.instance.post('admin/verify-mfa', { mfa_token: mfaToken, otp }).then(() => {
		return { message: 'Successfully logged in.' };
	});
}

export async function ResendMFA(mfaToken: string): Promise<void> {
	return axiosConfig.instance.post('admin/resend-mfa', { mfa_token: mfaToken }).then(() => {
		return;
	});
}
